import React, { useState } from 'react';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', company: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setStatus('error');
      return;
    }
    // mailto fallback — replace with EmailJS when configured
    const subject = encodeURIComponent(`9works Inquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nCompany: ${form.company}\n\nMessage:\n${form.message}`
    );
    window.location.href = `mailto:contact@ninea.ai?subject=${subject}&body=${body}`;
    setStatus('sent');
    setForm({ name: '', email: '', company: '', message: '' });
  };

  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Contact</div>
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Ready to transform your workforce management?
            Reach out and we'll get back to you within 24 hours.
          </p>
        </div>
        <div className="contact-grid">
          <div className="contact-info fade-in">
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Email</div>
                <div className="contact-info-value">contact@ninea.ai</div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Headquarters</div>
                <div className="contact-info-value">India</div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Website</div>
                <div className="contact-info-value">9works.in</div>
              </div>
            </div>
            <div style={{ marginTop: '32px', padding: '24px', background: 'var(--green-50)', borderRadius: 'var(--radius-md)', border: '1px solid var(--green-100)' }}>
              <div style={{ fontSize: '15px', fontWeight: 700, color: 'var(--gray-900)', marginBottom: '6px' }}>
                A product by ninea.ai
              </div>
              <div style={{ fontSize: '14px', color: 'var(--gray-500)', lineHeight: 1.65 }}>
                Building human-centered AI software solutions trusted across 50+ countries.
                Visit <a href="https://www.ninea.ai" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--green-primary)', textDecoration: 'none', fontWeight: 600 }}>ninea.ai</a> to learn more.
              </div>
            </div>
          </div>

          <div className="contact-form fade-in fade-in-delay-2">
            {status === 'sent' ? (
              <div className="form-success">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--green-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <div style={{ fontSize: '20px', marginBottom: '8px' }}>Message Ready!</div>
                <div style={{ color: 'var(--gray-500)', fontWeight: 400 }}>Your email client should open with the pre-filled message.</div>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Full Name *</label>
                  <input className="form-input" type="text" name="name" value={form.name} onChange={handleChange} placeholder="John Doe" />
                </div>
                <div className="form-group">
                  <label className="form-label">Work Email *</label>
                  <input className="form-input" type="email" name="email" value={form.email} onChange={handleChange} placeholder="john@company.com" />
                </div>
                <div className="form-group">
                  <label className="form-label">Company</label>
                  <input className="form-input" type="text" name="company" value={form.company} onChange={handleChange} placeholder="Company name" />
                </div>
                <div className="form-group">
                  <label className="form-label">Message *</label>
                  <textarea className="form-textarea" name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your workforce management needs..."></textarea>
                </div>
                {status === 'error' && (
                  <div style={{ color: '#ef4444', fontSize: '13px', marginBottom: '12px' }}>Please fill in all required fields.</div>
                )}
                <button type="submit" className="btn btn-primary form-submit btn-large">
                  Send Message
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                  </svg>
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
